
export class Redirecter {

  static goToNewMarketingPages() {
    window.open('https://home.86borders.com',"_self");
  }
}
